import script from "./SmallCheckItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SmallCheckItem.vue?vue&type=script&setup=true&lang=js"

import "./SmallCheckItem.vue?vue&type=style&index=0&id=7e546043&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e546043"]])

export default __exports__